export const hallConstraints = {
  name: {
    minLength: 1,
    maxLength: 128,
  },
  description: {
    minLength: 0,
    maxLength: 255,
  },
  link: {
    minLength: 5,
    maxLength: 32,
  },
}
